import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({ totals = {}, month = "JULY", year = "2026" }) {
 // console.log("WGRGrandTotal totals:", totals);

  // =========================
  // DEBIT
  // =========================
  const ob = Number(totals.OB) || 0;

  const labour = Number(totals.labour) || 0;
  const store = Number(totals.store) || 0;
  const freight = Number(totals.freight) || 0;
  const proforma = Number(totals.proforma) || 0;

  // Total Debit
  const totalDebit = labour + store + freight + proforma;

  // Grand Total Debit
  const grandTotalDebit = ob + totalDebit;

  // =========================
  // DETAILS OF REVENUE
  // =========================
  const dn5 = Number(totals.jv5) || 0;
  const dn6 = Number(totals.jv6) || 0;
  const dn7 = Number(totals.jv7) || 0;
  const dn12 = Number(totals.jv12) || 0;

  const part1 = Number(totals.part1) || 0;
  const bulkOrder = Number(totals.bulkorder) || 0;

  // Total Revenue
  const totalRevenue =
    dn5 +
    dn6 +
    dn7 +
    dn12 +
    part1 +
    bulkOrder;

  // =========================
  // CREDIT
  // =========================
  const poh = Number(totals.POH) || 0;
  const drr = Number(totals.DRR) || 0;
  const returnStore = Number(totals.ReturnStore) || 0;
  const electrical = Number(totals.Electrical) || 0;

  // Revenue Total is included in Credit
  const revenueTotal = totalRevenue;

  // Total Credit
  const totalCredit =
    poh +
    drr +
    returnStore +
    electrical +
    revenueTotal;

  // Closing Balance
  const closingBalance = grandTotalDebit - totalCredit;

  // Grand Total Credit
  const grandTotalCredit = totalCredit + closingBalance;

  return (
   <Paper
  elevation={4}
  sx={{
    mt: 3,
    border: "1px solid #444",
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
  }}
>
  <TableContainer
    sx={{
      width: "100%",
      maxWidth: "100%",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
    }}
  >
    <Table
      size="small"
      sx={{
        minWidth: 1580,
        width: "max-content",
        borderCollapse: "collapse",

        "& th, & td": {
          border: "1px solid #777",
          padding: {
            xs: "4px 6px",
            sm: "6px 8px",
          },
          fontSize: {
            xs: "11px",
            sm: "13px",
          },
          whiteSpace: "nowrap",
        },
      }}
    >
        {/* =========================
            MAIN HEADINGS
        ========================= */}
        <TableHead>
          <TableRow>
            <TableCell
              colSpan={2}
              align="center"
              sx={{
                backgroundColor: "#b6efb6",
                fontWeight: 800,
                fontSize: "18px !important",
              }}
            >
              DEBIT
            </TableCell>

            <TableCell
              colSpan={2}
              align="center"
              sx={{
                backgroundColor: "#fff9b0",
                fontWeight: 800,
                fontSize: "18px !important",
              }}
            >
              DETAILS OF REVENUE
            </TableCell>

            <TableCell
              colSpan={2}
              align="center"
              sx={{
                backgroundColor: "#f5b6b6",
                fontWeight: 800,
                fontSize: "18px !important",
              }}
            >
              CREDIT
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell
              sx={{
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              PARTICULARS
            </TableCell>

            <TableCell
              sx={{
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              AMOUNT
            </TableCell>

            <TableCell
              sx={{
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              PARTICULARS
            </TableCell>

            <TableCell
              sx={{
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              AMOUNT
            </TableCell>

            <TableCell
              sx={{
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              PARTICULARS
            </TableCell>

            <TableCell
              sx={{
                fontWeight: 700,
                textAlign: "center",
              }}
            >
              AMOUNT
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {/* =========================
              ROW 1
          ========================= */}
          <TableRow>
            <TableCell
              sx={{
                fontWeight: 700,
                backgroundColor: "#c6f5c6",
              }}
            >
              OPENING BALANCE
            </TableCell>

            <TableCell
              align="right"
              sx={{
                fontWeight: 700,
                backgroundColor: "#c6f5c6",
              }}
            >
              <CurrencyCell value={ob} />
            </TableCell>

            <TableCell />

            <TableCell />

            <TableCell />

            <TableCell />
          </TableRow>

          {/* =========================
              ROW 2
          ========================= */}
          <TableRow>
            <TableCell>LABOUR</TableCell>

            <TableCell align="right">
              <CurrencyCell value={labour} />
            </TableCell>

            <TableCell>DEMAND NO. 5</TableCell>

            <TableCell align="right">
              <CurrencyCell value={dn5} />
            </TableCell>

            <TableCell>COST OF POH/IOH FOREIGN RAILWAY</TableCell>

            <TableCell align="right">
              <CurrencyCell value={poh} />
            </TableCell>
          </TableRow>

          {/* =========================
              ROW 3
          ========================= */}
          <TableRow>
            <TableCell>STORE</TableCell>

            <TableCell align="right">
              <CurrencyCell value={store} />
            </TableCell>

            <TableCell>DEMAND NO. 6</TableCell>

            <TableCell align="right">
              <CurrencyCell value={dn6} />
            </TableCell>

            <TableCell>DRR</TableCell>

            <TableCell align="right">
              <CurrencyCell value={drr} />
            </TableCell>
          </TableRow>

          {/* =========================
              ROW 4
          ========================= */}
          <TableRow>
            <TableCell>FREIGHT</TableCell>

            <TableCell align="right">
              <CurrencyCell value={freight} />
            </TableCell>

            <TableCell>DEMAND NO. 7</TableCell>

            <TableCell align="right">
              <CurrencyCell value={dn7} />
            </TableCell>

            <TableCell>RETURN STORE</TableCell>

            <TableCell align="right">
              <CurrencyCell value={returnStore} />
            </TableCell>
          </TableRow>

          {/* =========================
              ROW 5
          ========================= */}
          <TableRow>
            <TableCell>PROFORMA ON COST</TableCell>

            <TableCell align="right">
              <CurrencyCell value={proforma} />
            </TableCell>

            <TableCell>DEMAND NO. 12</TableCell>

            <TableCell align="right">
              <CurrencyCell value={dn12} />
            </TableCell>

            <TableCell>ELECT. MANUFACTURING</TableCell>

            <TableCell align="right">
              <CurrencyCell value={electrical} />
            </TableCell>
          </TableRow>

          {/* =========================
              ROW 6
          ========================= */}
          <TableRow>
            <TableCell />

            <TableCell />

            <TableCell>TD/XP/Part I (00-0882-22)</TableCell>

            <TableCell align="right">
              <CurrencyCell value={part1} />
            </TableCell>

            <TableCell>REVENUE TOTAL</TableCell>

            <TableCell
              align="right"
              sx={{
                fontWeight: 700,
              }}
            >
              <CurrencyCell value={revenueTotal} />
            </TableCell>
          </TableRow>

          {/* =========================
              ROW 7 - BULK ORDER
          ========================= */}
          <TableRow>
            <TableCell />

            <TableCell />

            <TableCell>BULK ORDER (21-2130-08)</TableCell>

            <TableCell align="right">
              <CurrencyCell value={bulkOrder} />
            </TableCell>

            <TableCell />

            <TableCell />
          </TableRow>

          {/* =========================
              TOTAL ROW
          ========================= */}
          <TableRow>
            <TableCell
              sx={{
                fontWeight: 800,
              }}
            >
              Total Debit ({month}-{year})
            </TableCell>

            <TableCell
              align="right"
              sx={{
                fontWeight: 800,
              }}
            >
              <CurrencyCell value={totalDebit} />
            </TableCell>

            <TableCell
              sx={{
                fontWeight: 800,
                backgroundColor: "#fff9b0",
              }}
            >
              Total of Revenue
            </TableCell>

            <TableCell
              align="right"
              sx={{
                fontWeight: 800,
                backgroundColor: "#fff9b0",
              }}
            >
              <CurrencyCell value={totalRevenue} />
            </TableCell>

            <TableCell
              sx={{
                fontWeight: 800,
              }}
            >
              Total Credit ({month}-{year})
            </TableCell>

            <TableCell
              align="right"
              sx={{
                fontWeight: 800,
              }}
            >
              <CurrencyCell value={totalCredit} />
            </TableCell>
          </TableRow>

          {/* =========================
              CLOSING BALANCE
          ========================= */}
          <TableRow>
            <TableCell />

            <TableCell />

            <TableCell />

            <TableCell />

            <TableCell
              sx={{
                backgroundColor: "#f5b6b6",
                fontWeight: 800,
              }}
            >
              CLOSING BALANCE
            </TableCell>

            <TableCell
              align="right"
              sx={{
                backgroundColor: "#f5b6b6",
                fontWeight: 800,
              }}
            >
              <CurrencyCell value={closingBalance} />
            </TableCell>
          </TableRow>

          {/* =========================
              GRAND TOTAL
          ========================= */}
          <TableRow>
            <TableCell
              sx={{
                fontWeight: 800,
              }}
            >
              GRAND TOTAL DEBIT
            </TableCell>

            <TableCell
              align="right"
              sx={{
                fontWeight: 800,
              }}
            >
              <CurrencyCell value={grandTotalDebit} />
            </TableCell>

            <TableCell />

            <TableCell />

            <TableCell
              sx={{
                fontWeight: 800,
              }}
            >
              GRAND TOTAL CREDIT
            </TableCell>

            <TableCell
              align="right"
              sx={{
                fontWeight: 800,
              }}
            >
              <CurrencyCell value={grandTotalCredit} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      </TableContainer>
    </Paper>
  );
}